import { connect } from 'react-redux'
import Dashboard from 'modules/Dashboard/index'
import {
    getDashboardDriveList
} from 'modules/Dashboard/actions'
import Selector from 'modules/Dashboard/selectors'

const mapStateToProps = state => ({
    dashboardDriveList : Selector.getDashboardDriveLists(state),
})

const mapDispatchToProps = {
    getDashboardDriveList
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
